export default "__VITE_ASSET__tlYADLF7__"